import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React, { useState, useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom'; // Correct import for useLocation
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import { Link } from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ProductContext } from "../context/AppContext";
import Footer from './Common_Components/Footer';
function JapaneseHSchoolDay1() {
  const [activePage, setActivePage] = useState("Learning");
  const navigate = useNavigate();
  const location = useLocation(); // Use useLocation hook correctly
  // const { title, imageUrl } = location.state || {};
  const SkitScreen = location.state;
  const dayId = SkitScreen?.dayId;
  const categoryId = SkitScreen?.categoryId;
  const dayName = SkitScreen?.dayName;
  const skitname = SkitScreen?.skitname;
  const dayLen = SkitScreen?.dayLen;
  const imageURL = SkitScreen?.imageURL;
  console.log("skit Screen Data :", dayId, categoryId, dayName, skitname, dayLen, imageURL);
  // const { dayId, categoryId, dayName, skitname, dayLen } = route.params;
  const authToken = localStorage.getItem("AuthToken");

  const [loading, setLoading] = useState(true);

  const [selectedLanguage, setSelectedLanguage] = useState('');
  const SelectLanguageLocal = localStorage.getItem("selectedLanguage");
  const { Translate } = useContext(ProductContext);
  const [imageUrl, setImageUrl] = useState('');
  useEffect(() => {
    const fetchImage = async () => {
      try {
        const response = await axios.get(
          `https://api.japaking.online/api/skit-day?categoryId=${categoryId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );

        if (response.data.success) {
          const day = response.data.message.days.find(
            day => day.day_id === dayId,
          );
          if (day) {
            setImageUrl(day.url);
          }
        }
      } catch (err) {
        if (err.response && err.response.status === 401) {
          // console.log('navigate to login due to 401');
          navigate('Home');
        }
        console.error('Error fetching image:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchImage();
  }, [dayId, categoryId]);
  return (
    <div className="JapaneseHSchoolDay1 d-flex flex-column" style={{ minHeight: '100vh' }}>
      <div className='header_inner' >
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <ArrowBackIosIcon onClick={() => navigate(-1)} className='icon_1' />
              {/* <h2>{title}</h2> */}
              <h2>{dayName}</h2>
              <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
            </div>
          </div>
        </div>
      </div>

      <div className="tiles-wrapper">
        <main className="JHS-content">
          <div className="JHS-image-container">
            <img
              src={imageUrl}
              alt={loading ? "Loading" : "Penguin"}
              className="JHS-image"
            />
          </div>
          <div className="JHS-button-container">
            <button
              onClick={() => {
                navigate('/LifeOldJapanDay0', {
                  state: {
                    categoryId: categoryId,
                    dayId: dayId,
                    dayName: dayName,
                    skitname: skitname,
                    dayLen: dayLen,
                    imageURL,
                  },
                });
              }}
              className="JHS-action-button"
            >
              {skitname}
            </button>
          </div>
        </main>
      </div>
      <Footer />
    </div>
  );
}

export default JapaneseHSchoolDay1;
